import Input from "@/app/_components/forms/Input";
import TextField, {TextFieldClasses} from "@/app/_components/forms/TextField";
import {ContactFormParentFields} from "./contactFormUtils";
import {ParentFieldHandlers} from "./useContactFormParentFields";
import {useUserInfo} from "@/app/_components/contexts/userInfoContext";
import {validatePhoneNumber} from "@/app/util/formUtils";

export type UninitializedParentFieldsBaseProps = {
	classes?: {
		fields?: TextFieldClasses;
	};
};

type UninitializedParentFieldsProps = Partial<ContactFormParentFields> &
	Partial<ParentFieldHandlers> &
	UninitializedParentFieldsBaseProps;

const UninitializedParentInputFields: React.FC<
	UninitializedParentFieldsProps
> = ({
	classes,
	parentFirstName,
	parentLastName,
	parentEmail,
	parentPhoneNumber,
	onParentFirstNameChange,
	onParentLastNameChange,
	onParentEmailChange,
	onParentPhoneNumberChange,
}) => {
	const {userInfo} = useUserInfo();
	// If the user is fully initialized, don't show these fields
	if (userInfo?.first_name && userInfo?.last_name && userInfo?.email) {
		return null;
	}
	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-col gap-4 md:flex-row md:gap-4">
				{!userInfo?.first_name && (
					<TextField
						isRequired
						name="parentFirstName"
						type="text"
						labelText="Parent First Name"
						autoComplete="section-parent given-name"
						value={parentFirstName}
						onInput={onParentFirstNameChange}
						classes={{
							root: "md:flex-1",
							...classes?.fields,
						}}
					>
						<Input />
					</TextField>
				)}
				{!userInfo?.last_name && (
					<TextField
						isRequired
						name="parentLastName"
						type="text"
						labelText="Parent Last Name"
						autoComplete="section-parent family-name"
						value={parentLastName}
						onInput={onParentLastNameChange}
						classes={{
							root: "md:flex-1",
							...classes?.fields,
						}}
					>
						<Input />
					</TextField>
				)}
			</div>
			{!userInfo?.email && (
				<TextField
					isRequired
					name="parentEmail"
					labelText="Parent Email"
					type="email"
					autoComplete="section-parent email"
					value={parentEmail}
					onInput={onParentEmailChange}
					classes={classes?.fields}
				>
					<Input />
				</TextField>
			)}
			{!userInfo && (
				<TextField
					isRequired
					name="parentPhoneNumber"
					labelText="Phone Number"
					type="tel"
					autoComplete="section-parent tel"
					value={parentPhoneNumber}
					onInput={onParentPhoneNumberChange}
					validate={validatePhoneNumber}
					validationBehavior="native"
					classes={classes?.fields}
				>
					<Input />
				</TextField>
			)}
		</div>
	);
};

export default UninitializedParentInputFields;
